import { useTranslation } from 'react-i18next';

/**
 * Filtre de plage de dates "Du/Au" + Appliquer/Réinitialiser — même UI que
 * WorkloadPage (Charge de travail), réutilisée telle quelle par
 * SynthesisPage et MasterPage. Contrairement à Charge de travail, il n'y a
 * pas de fenêtre par défaut ici : sans plage appliquée, aucun filtre de date
 * n'est envoyé au serveur (voir FoldersService.parseCustomWindow) —
 * "Réinitialiser" n'est donc affiché que si `onReset` est fourni (une plage
 * est active).
 */
export function DateRangeFilter({
  startInput,
  endInput,
  onStartInputChange,
  onEndInputChange,
  onApply,
  onReset,
  applyDisabled,
}: {
  startInput: string;
  endInput: string;
  onStartInputChange: (value: string) => void;
  onEndInputChange: (value: string) => void;
  onApply: () => void;
  onReset: (() => void) | null;
  applyDisabled: boolean;
}) {
  const { t } = useTranslation();

  return (
    <div className="toolbar" style={{ margin: '4px 0 8px', alignItems: 'center' }}>
      <label style={{ fontSize: 13, color: 'var(--color-text-muted)' }}>{t('synthesis.windowFrom')}</label>
      <input type="date" value={startInput} onChange={(e) => onStartInputChange(e.target.value)} />
      <label style={{ fontSize: 13, color: 'var(--color-text-muted)' }}>{t('synthesis.windowTo')}</label>
      <input type="date" value={endInput} onChange={(e) => onEndInputChange(e.target.value)} />
      <button className="btn" disabled={applyDisabled} onClick={onApply}>
        {t('synthesis.applyRange')}
      </button>
      {onReset && (
        <button className="btn" onClick={onReset}>
          {t('synthesis.resetRange')}
        </button>
      )}
    </div>
  );
}
